import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import { TokenValidatorService } from './shared/services/token-validator.service';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [ 
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent implements OnInit, OnDestroy {
    location: any;
    routerSubscription: any;

    constructor(
        private router: Router,
        private tokenValidator: TokenValidatorService
    ) {
    }

    ngOnInit(){
        this.recallJsFuntions();
        
        // Inicia a validação do token
        // Verifica a cada 1 minuto se o token está válido
        this.tokenValidator.startTokenValidation(1);
        
        // Configura aviso quando o token estiver prestes a expirar (últimos 30 minutos)
        // this.tokenValidator.setupExpirationWarning(30);
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                $.getScript('../assets/js/custom.js');
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0)
            });
    }

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
        
        // Para a validação periódica do token
        this.tokenValidator.stopTokenValidation();
    }
}
